module.exports = __webpack_public_path__ + "img/005.73e0991f.png";